module.exports = __webpack_public_path__ + "static/img/radar-no-result.7d992872.png";